import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoIcon from "../Images/logo_icon.png";

export function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/about", label: "About Us" },
    { to: "/contact", label: "Contact" },
  ];

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header-wrapper">
      <div className="container header-container">
        <Link to="/" className="brand-link" onClick={closeMobileMenu}>
          <img
            src={logoIcon}
            className="brand-logo"
            alt="Advanced Cloudlink Technologies Logo"
          />
          <div className="brand-info">
            <span className="brand-name">Advanced Cloudlink</span>
            <span className="brand-tagline">Technologies Inc</span>
          </div>
        </Link>

        <nav>
          <ul className="nav-links">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={`nav-item ${location.pathname === item.to ? "active" : ""}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="nav-cta-btn">
                Schedule Consultation
              </Link>
            </li>
          </ul>
        </nav>

        <button
          className="mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          {mobileMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Drawer */}
      <div className={`mobile-nav-drawer ${mobileMenuOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`mobile-nav-link ${location.pathname === item.to ? "active" : ""}`}
            onClick={closeMobileMenu}
          >
            {item.label}
          </Link>
        ))}
        <Link
          to="/contact"
          className="nav-cta-btn"
          style={{ textAlign: "center", marginTop: "0.5rem" }}
          onClick={closeMobileMenu}
        >
          Schedule Consultation
        </Link>
      </div>
    </header>
  );
}
